import React, { useState } from 'react';
import { EXAMPLE_ADDRESSES } from '../utils/constants';

interface AddressInputProps {
  onSearch: (addresses: string[], prefix: string) => void;
  isSearching: boolean;
  disabled?: boolean;
}

const AddressInput: React.FC<AddressInputProps> = ({
  onSearch,
  isSearching,
  disabled = false
}) => {
  const [addresses, setAddresses] = useState<string>('');
  const [prefix, setPrefix] = useState<string>('');

  const handleSearch = () => {
    if (!addresses.trim()) {
      alert('请输入要搜索的地址');
      return;
    }

    const addressList = addresses
      .split('\n')
      .map(addr => addr.trim())
      .filter(addr => addr.length > 0);

    if (addressList.length === 0) {
      alert('请输入有效的地址');
      return;
    }

    onSearch(addressList, prefix.trim());
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.ctrlKey && e.key === 'Enter') {
      e.preventDefault();
      handleSearch();
    }
  };

  const loadExampleAddresses = () => {
    setAddresses(EXAMPLE_ADDRESSES.join('\n'));
    setPrefix('');
  };

  return (
    <div className="address-input-panel">
      <div className="input-group">
        <div className="input-row">
          <label className="input-label">地址前缀（可选）</label>
          <input
            type="text"
            className="input"
            value={prefix}
            onChange={(e) => setPrefix(e.target.value)}
            placeholder="例如：北京市"
            disabled={disabled || isSearching}
          />
        </div>

        <div className="input-row">
          <div className="input-header">
            <label className="input-label">输入地址（每行一个）</label>
            <button
              type="button"
              className="btn btn-link btn-xs"
              onClick={loadExampleAddresses}
              disabled={disabled || isSearching}
            >
              加载示例
            </button>
          </div>
          <textarea
            className="textarea"
            value={addresses}
            onChange={(e) => setAddresses(e.target.value)}
            onKeyDown={handleKeyDown}
            placeholder="每行输入一个地址，例如：&#10;朝阳区建国门外大街1号国贸大厦&#10;黄浦区南京东路20号"
            rows={10}
            disabled={disabled || isSearching}
          />
          <div className="input-hint">
            提示：按 Ctrl+Enter 快速开始搜索
          </div>
        </div>

        <div className="input-actions">
          <button
            className="btn btn-primary btn-lg"
            onClick={handleSearch}
            disabled={disabled || isSearching || !addresses.trim()}
          >
            {isSearching ? (
              <>
                <span className="spinner"></span>
                搜索中...
              </>
            ) : (
              '开始搜索'
            )}
          </button>
        </div>
      </div>

      {disabled && !isSearching && (
        <div className="input-disabled-notice">
          <div className="notice-icon">ℹ️</div>
          <div className="notice-text">
            请先配置API密钥并初始化地图
          </div>
        </div>
      )}
    </div>
  );
};

export default AddressInput;
